/**
 * @param {[import("@seabrookstudios/pitch2table-core").PublisherForApp, import("@seabrookstudios/pitch2table-core").ContactBookPublisher|undefined, ...unknown[]]} tuple
 * @param {string} filter
 */
export const publisherNameMatchesFilter = (tuple, filter) => {
  const text = filter.toLowerCase();
  if (!text) {
    return true;
  }

  const [publisher, myPublisher] = tuple;
  const name = (myPublisher?.name || publisher.name).toLowerCase();
  if (name.includes(text)) {
    return true;
  }

  return (publisher.alternateNames ?? []).some((alternate) => alternate.toLowerCase().includes(text));
};
